import useMediaQuery from "@mui/material/useMediaQuery";
import { Link, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { AppContext } from "../../../context/AppContext";

const MunikLogo = ({ height }) => {

  const res = useContext(AppContext);
  let navigate = useNavigate();

  const setUser = res?.appLoadingStates?.setUser;
  const user = res?.appLoadingStates?.user;

  let sm = useMediaQuery("(max-width:600px)");
  return (
    <Link to={`/dashboard/${user.uid}`}>
      <img
        src="/assets/navbar/munik-logo.png"
        alt="munik-logo"
        height={sm ? 70 : 90}
        width={sm ? 100 : 150}
      />
    </Link>
  );
};

export default MunikLogo;
